import { Injectable, inject } from '@angular/core';
import {
  AppConfigService,
  IDP_APPS
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { take } from 'rxjs/operators';

/**
 * Handles redirect to login page when user is not authenticated.
 * Used internally by AppAuthGuard.
 */
@Injectable({
  providedIn: 'root'
})
export class AppAuthRedirectHelper {
  private appConfig = inject(AppConfigService);

  /** Redirects to the login page with current URL as refreshURL */
  redirect(): void {
    this.appConfig
      .getConfigValue(IDP_APPS.COMMON, 'LOGIN_URL')
      .pipe(take(1))
      .subscribe((loginUrl) => {
        const pathname = window.location.pathname;
        const search = window.location.search;
        const fullPath = pathname + (search ? search : '');
        const url = `${window.location.origin}${loginUrl}?refreshURL=${encodeURIComponent(fullPath)}`;
        window.open(url, '_self');
      });
  }
}
